import * as agGrid from 'ag-grid-angular';
import * as agGridEnterprise from 'ag-grid-enterprise';
import * as agGridCommunity from 'ag-grid-community';
// NOTE only import dutch
import { AG_GRID_LOCALE_NL } from '@ag-grid-community/locale';

const agGridLocale = {
    AG_GRID_LOCALE_NL
};

window['ag-grid-angular'] = agGrid;
window['ag-grid-enterprise'] = agGridEnterprise;
window['ag-grid-community'] = agGridCommunity;
window['@ag-grid-community'] = { locale: agGridLocale };

export { agGrid, agGridEnterprise, agGridLocale };